module.exports = __webpack_public_path__ + "img/tariffs.bc253a71.svg";